import { RankedTester, and, isControl, optionIs, rankWith } from "@jsonforms/core";

const EventAttendanceManagementTester: RankedTester = rankWith(
  20,
  and(isControl, optionIs("EventAttendanceManagement", true))
);

export default EventAttendanceManagementTester;
